import React from 'react';
import Header from '@/components/Header';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft, Mail, Phone, MapPin, Globe, Award, Users, BookOpen, Calendar, Star } from 'lucide-react';
const Profile = () => {
    return (<div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50">
      <Header />
      
      <div className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 text-white py-20 relative overflow-hidden">
        
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(255,255,255,0.1),transparent_50%)]"></div>
          <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full mix-blend-multiply filter blur-3xl"></div>
          <div className="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full mix-blend-multiply filter blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            
            <div className="mb-8 animate-fade-in-up">
              <Link to="/articles">
                <Button variant="outline" className="bg-transparent border-white text-white hover:bg-white hover:text-primary transition-all duration-300 transform hover:scale-105 hover-glow">
                  <ArrowLeft className="ml-2 h-4 w-4"/>
                  بازگشت به مقالات
                </Button>
              </Link>
            </div>
            
            
            <div className="mb-8 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
              <div className="w-32 h-32 rounded-full flex items-center justify-center mx-auto mb-6 overflow-hidden border-4 border-white/30 shadow-2xl">
                <img src="/images/logo.png" alt="آزمایشگاه سلامت" className="w-full h-full object-cover"/>
              </div>
              <h1 className="text-4xl md:text-5xl font-bold mb-4">آزمایشگاه تشخیص پزشکی سلامت</h1>
              <p className="text-xl opacity-90 max-w-2xl mx-auto leading-relaxed">
                مرکز تخصصی تشخیص و درمان با پیشرفته‌ترین تجهیزات و کادر پزشکی مجرب
              </p>
            </div>

            
            <div className="flex justify-center items-center space-x-8 space-x-reverse animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
              <div className="flex items-center space-x-2 space-x-reverse">
                <Users className="w-5 h-5"/>
                <span className="text-sm opacity-90">تیم متخصص</span>
              </div>
              <div className="w-1 h-6 bg-white/30 rounded-full"></div>
              <div className="flex items-center space-x-2 space-x-reverse">
                <Award className="w-5 h-5"/>
                <span className="text-sm opacity-90">کیفیت برتر</span>
              </div>
              <div className="w-1 h-6 bg-white/30 rounded-full"></div>
              <div className="flex items-center space-x-2 space-x-reverse">
                <BookOpen className="w-5 h-5"/>
                <span className="text-sm opacity-90">مقالات علمی</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-3 gap-8">
            
            <div className="lg:col-span-2">
              <Card className="p-8 border-0 shadow-xl rounded-3xl hover-lift mb-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-3">
                  <Award className="w-6 h-6 text-blue-600"/>
                  درباره ما
                </h2>
                <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed">
                  <p className="mb-4">
                    آزمایشگاه سلامت با بیش از ۲۰ سال تجربه در زمینه تشخیص و درمان، یکی از پیشرفته‌ترین مراکز آزمایشگاهی در کشور است. 
                    ما با استفاده از جدیدترین تکنولوژی‌ها و کادر پزشکی مجرب، خدمات با کیفیتی را به مراجعین ارائه می‌دهیم.
                  </p>
                  <p className="mb-4">
                    هدف ما ارائه خدمات تشخیصی دقیق و قابل اعتماد با رعایت بالاترین استانداردهای کیفیت و ایمنی است. 
                    تیم متخصص ما متشکل از پزشکان، تکنسین‌ها و کارشناسان مجرب است که همگی متعهد به ارائه بهترین خدمات هستند.
                  </p>
                  <p>
                    ما در تلاش هستیم تا با بهره‌گیری از دانش روز دنیا و تجهیزات پیشرفته، 
                    گامی مهم در ارتقای سلامت جامعه برداریم.
                  </p>
                </div>
              </Card>

              
              <Card className="p-8 border-0 shadow-xl rounded-3xl hover-lift mb-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-3">
                  <BookOpen className="w-6 h-6 text-purple-600"/>
                  خدمات ما
                </h2>
                <div className="grid md:grid-cols-2 gap-4">
                  {[
            'آزمایشات خون و ادرار',
            'تست‌های تخصصی',
            'آزمایشات ژنتیکی',
            'تست‌های آلرژی',
            'آزمایشات هورمونی',
            'تست‌های میکروبیولوژی',
            'آزمایشات مولکولی',
            'تست‌های ایمونولوژی'
        ].map((service, index) => (<div key={index} className="flex items-center gap-3 p-3 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-100">
                      <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                      <span className="text-gray-700 font-medium">{service}</span>
                    </div>))}
                </div>
              </Card>

              
              <Card className="p-8 border-0 shadow-xl rounded-3xl hover-lift">
                <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-3">
                  <Star className="w-6 h-6 text-yellow-600"/>
                  دستاوردها و گواهینامه‌ها
                </h2>
                <div className="grid md:grid-cols-2 gap-6">
                  {[
            { title: 'ISO 15189', description: 'گواهینامه کیفیت بین‌المللی' },
            { title: 'CAP', description: 'گواهینامه انجمن پاتولوژی آمریکا' },
            { title: 'JCI', description: 'گواهینامه بین‌المللی بهداشت' },
            { title: 'وزارت بهداشت', description: 'تاییدیه رسمی وزارت بهداشت' }
        ].map((achievement, index) => (<div key={index} className="p-4 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl border border-green-100 text-center">
                      <h4 className="font-bold text-green-800 mb-2">{achievement.title}</h4>
                      <p className="text-green-600 text-sm">{achievement.description}</p>
                    </div>))}
                </div>
              </Card>
            </div>

            
            <div className="lg:col-span-1">
              
              <Card className="p-6 border-0 shadow-xl rounded-2xl mb-6 hover-lift">
                <h3 className="font-bold text-gray-800 mb-4 flex items-center gap-2">
                  <Mail className="w-5 h-5 text-blue-600"/>
                  اطلاعات تماس
                </h3>
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <Mail className="w-4 h-4 text-gray-500"/>
                    <span className="text-gray-600">info@salamatlab.com</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <Phone className="w-4 h-4 text-gray-500"/>
                    <span className="text-gray-600">۰۲۱-۴۶۸۳۳۰۱۰ | ۰۲۱-۴۶۸۳۳۰۱۱</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <MapPin className="w-4 h-4 text-gray-500"/>
                    <span className="text-gray-600">شهرقدس، میدان مصلی</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <Globe className="w-4 h-4 text-gray-500"/>
                    <span className="text-gray-600">www.salamatlab.com</span>
                  </div>
                </div>
              </Card>

              
              <Card className="p-6 border-0 shadow-xl rounded-2xl mb-6 hover-lift">
                <h3 className="font-bold text-gray-800 mb-4 flex items-center gap-2">
                  <Calendar className="w-5 h-5 text-purple-600"/>
                  ساعات کاری
                </h3>
                <div className="space-y-3">
                  <div className="flex justify-between">
                    <span className="text-gray-600">شنبه تا چهارشنبه</span>
                    <span className="font-bold text-gray-800">06:00 تا 21:00</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">پنج‌شنبه</span>
                    <span className="font-bold text-gray-800">06:00 تا 20:30</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">جمعه</span>
                    <span className="font-bold text-gray-800">تعطیل</span>
                  </div>
                </div>
              </Card>

              
              <Card className="p-6 border-0 shadow-xl rounded-2xl hover-lift">
                <h3 className="font-bold text-gray-800 mb-4">دسترسی سریع</h3>
                <div className="space-y-3">
                  <Link to="/articles">
                    <Button variant="outline" className="w-full justify-start hover:bg-blue-50 hover:border-blue-300 transition-all duration-300">
                      <BookOpen className="w-4 h-4 ml-2"/>
                      مقالات علمی
                    </Button>
                  </Link>
                  <Link to="/">
                    <Button variant="outline" className="w-full justify-start hover:bg-green-50 hover:border-green-300 transition-all duration-300">
                      <Globe className="w-4 h-4 ml-2"/>
                      صفحه اصلی
                    </Button>
                  </Link>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>);
};
export default Profile;
